import { useEffect } from 'react';
import { getFocusableElements, getNextFocusableElement } from '@hivebrite/utils';
export const useFocusTrap = (containerRef, isActive) => {
    useEffect(() => {
        if (!isActive || !containerRef) {
            return undefined;
        }
        const focusableElements = getFocusableElements(containerRef);
        const firstFocusable = focusableElements[0];
        const handleTabKey = (event) => {
            if (event.key !== 'Tab') {
                return;
            }
            if (!(containerRef === null || containerRef === void 0 ? void 0 : containerRef.contains(document.activeElement))) {
                event.preventDefault();
                firstFocusable === null || firstFocusable === void 0 ? void 0 : firstFocusable.focus();
                return;
            }
            event.preventDefault();
            const direction = event.shiftKey ? -1 : 1;
            const nextElement = getNextFocusableElement(containerRef, direction);
            nextElement === null || nextElement === void 0 ? void 0 : nextElement.focus();
        };
        const handleFocus = (event) => {
            if (!(containerRef === null || containerRef === void 0 ? void 0 : containerRef.contains(event.target))) {
                firstFocusable === null || firstFocusable === void 0 ? void 0 : firstFocusable.focus();
            }
        };
        firstFocusable === null || firstFocusable === void 0 ? void 0 : firstFocusable.focus();
        document.addEventListener('keydown', handleTabKey);
        document.addEventListener('focusin', handleFocus);
        return () => {
            document.removeEventListener('keydown', handleTabKey);
            document.removeEventListener('focusin', handleFocus);
        };
    }, [containerRef, isActive]);
};
//# sourceMappingURL=useFocusTrap.js.map